if (!customElements.get('oa-footer-leaves')) {
  customElements.define('oa-footer-leaves', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) this.classList.toggle('is-visible', entry.isIntersecting);
      }, {threshold: 0.01});
      this.observer.observe(this);
    }
    disconnectedCallback() {this.observer?.disconnect();}
  });
}
